export default __webpack_public_path__ + "static/Tek_Trapdoor-5241583b4eda5bd505ef16e2564e8782.png";